import { render, staticRenderFns } from "./AlbumPostCreate.vue?vue&type=template&id=60a6828a&scoped=true"
import script from "./AlbumPostCreate.vue?vue&type=script&lang=js"
export * from "./AlbumPostCreate.vue?vue&type=script&lang=js"
import style0 from "./AlbumPostCreate.vue?vue&type=style&index=0&id=60a6828a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a6828a",
  null
  
)

export default component.exports